import consumer from '../../../channels/consumer'

class ExcelImportChannel {
  constructor(execlImportId) {
    this.setExcelImportCableSubscriptions(execlImportId)
  }

  setExcelImportCableSubscriptions(execlImportId) {
    consumer.subscriptions.create({ channel: 'SimpleRulesUi::ExcelImportChannel', id: execlImportId }, {
      received(data) {
        document.querySelector('#importRules #log-message').innerHTML = data.log_message

        const submitBtn = document.querySelector('#importRules #submit-btn')
        submitBtn.innerHTML = 'Importar'
        submitBtn.disabled = false
      },
    })
  }
}

export default ExcelImportChannel
